// extracted by mini-css-extract-plugin
module.exports = {"expandedRowsWrapper":"ExpandedRows_expandedRowsWrapper__32tl8","expandedRows":"ExpandedRows_expandedRows__1pK7u"};